module.exports = __webpack_public_path__ + "static/img/A2E_India_training_4K5A7194.f91d6b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/outreach/A2E_India_training_4K5A7194.jpg
// module id = ocX0
// module chunks = 0